module.exports = __webpack_public_path__ + "static/media/29150016-min.260cbea2.jpg";